import Footer from "../../mainComponents/footer";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAuth from "../../../hooks/useAuth";
import { fetchStepsLog } from "../utils/fetchStepsLog";


import React from "react";

// Styling
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import '../../../css/StepLog.css';  // Assuming a new CSS file for step logs

// Translation
import { useTranslation } from 'react-i18next';

export default function StepLog({ isNavOpen }) {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState(null);
  const { auth } = useAuth();
  const [infoRowId, setInfoRowId] = useState(null);

  useEffect(() => {
    const loadLogs = async () => {
      try {
        const logsData = await fetchStepsLog(axiosPrivate);
        if (logsData && Array.isArray(logsData)) {
          if (logsData.length === 0) {
            setError('No step logs found');
          }
          setLogs(logsData);
        } else {
          setLogs([]);
          setError('No step logs found');
        }
      } catch (err) {
        setError(err.message);
      }
    };
    loadLogs();
  }, []);

  // Function to get the name of the modifier based on user ID
  const getUserNameById = (userId) => {
    // Assuming there's a function that gets the user name from a list or an API call
    return userId ? `User-${userId}` : 'Unknown';
  };

  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
      <div className="admin-users tx1">
        <h2>{t('stepLog.title')}</h2>
        {error && error !== "No step logs found" && (
          <p className="error-message">{error}</p>
        )}

        {/* {console.log(logs)} */}

        {logs.length > 0 ? (

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>{t('stepLog.userId')}</th>
                  <th>{t('stepLog.username')}</th>
                  <th>{t('stepLog.action')}</th>
                  <th>{t('stepLog.stepNameAndId')}</th>
                  <th>{t('stepLog.timestamp')}</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <React.Fragment key={log.id}>
                    <tr>
                      <td>
                        {log.modified_by_user_id}
                      </td>
                      <td>
                        {log.modified_by_user}
                      </td>
                      <td>
                        {log.action_type}
                      </td>
                      <td>
                        {`${log.step_name} (Id: ${log.step_id})`}
                      </td>
                      <td>
                        {new Date(log.timestamp).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false,
                        })}
                      </td>

                    </tr>

                    {/* ✅ Full-width info row */}
                    {infoRowId === log.id && (
                      <tr>
                        <td colSpan={4} className="info-row">
                          <p>
                            {t(`stepLog.${log.action_type}_info`)}  {/* Assuming translation keys for each action */}
                          </p>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>{t('stepLog.noLogs')}</p>
        )}
      </div>
    </div>
  );
}
